export default "__VITE_ASSET__DTw9eGi$__"